import type { InputMappingGroup } from '@/features/InputMapping/types';
import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import { formatChoice } from '@/utils/formatters/simpleChoice';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';

export const beitragsreduzierungsGroupMapping: InputMappingGroup = {
  icon: 'badge-percent',
  label: 'Mögliche Beitragsreduzierung',
  infos: [
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            path: 'vorversicherung.gesellschaftID',
            formatter: formatChoice(SIMPLE_CHOICE.GESELLSCHAFTEN_TS),
          },
          {
            path: 'vorversicherung.dauer',
          },
        ],
      },

      requiredPaths: [
        'vorversicherung.gesellschaftID',
        'vorversicherung.dauer',
      ],
      requiredOr: true,
    },
  ],
};
